<template>
	<van-tabbar route  active-color="#07c160" inactive-color="#999" style="box-shadow: 0 -2px 6px #eee;">
	  <van-tabbar-item replace to="/" icon="shop">
	    微官网
	  </van-tabbar-item>
	  <van-tabbar-item replace to="/course_list" icon="video-o">
	    我的课程
	  </van-tabbar-item>
	  <van-tabbar-item replace to="/usercenter" icon="manager-o">
	    会员中心
	  </van-tabbar-item>
	</van-tabbar>
</template>

<script>
	export default {
	  name: 'Tabbar',
	}
</script>

<style>
</style>
